module.exports = __webpack_public_path__ + "static/media/NathanL.f9dfb518.jpg";